module.exports = __webpack_public_path__ + "img/auth-bg.b5c5ab66.png";